import { all, takeEvery, fork, call, put } from "redux-saga/effects";
import { rakutenScoringSettingService, uploadService } from "@iso/services";
import actions from "./actions";

function* createSetting() {
  yield takeEvery(actions.CREATE_REQUEST, function* ({ payload }) {
    const { data, resolve, reject } = payload;
    try {
      const response = yield call(rakutenScoringSettingService.create, data);
      yield put({ type: actions.CREATE_SUCCESS });
      resolve(response);
    } catch (error) {
      yield put({ type: actions.CREATE_ERROR, error: error.response });
      reject(error);
    }
  });
}

function* getDetail() {
  yield takeEvery(actions.GET_DETAIL_REQUEST, function* ({ payload }) {
    const { batchCrawlSettingId, resolve, reject } = payload;
    try {
      const response = yield call(rakutenScoringSettingService.getDetail, batchCrawlSettingId);
      yield put({ type: actions.GET_DETAIL_SUCCESS, detail: response });
      resolve(response);
    } catch (error) {
      yield put({ type: actions.GET_DETAIL_ERROR, error: error.response });
      reject(error);
    }
  });
}

function* updateSetting() {
  yield takeEvery(actions.UPDATE_REQUEST, function* ({ payload }) {
    const { batchCrawlSettingId, data, resolve, reject } = payload;
    try {
      const response = yield call(
        rakutenScoringSettingService.update,
        batchCrawlSettingId,
        data
      );
      yield put({ type: actions.UPDATE_SUCCESS });
      resolve(response);
    } catch (error) {
      yield put({ type: actions.UPDATE_ERROR, error: error.response });
      reject(error);
    }
  });
}

function* executeSetting() {
  yield takeEvery(actions.EXECUTE_REQUEST, function* ({ payload }) {
    const { batchCrawlSettingId, resolve, reject } = payload;
    try {
      const response = yield call(rakutenScoringSettingService.execute, batchCrawlSettingId);
      yield put({ type: actions.EXECUTE_SUCCESS });
      resolve(response);
    } catch (error) {
      yield put({ type: actions.EXECUTE_ERROR, error: error.response });
      reject(error);
    }
  });
}

function* cancelSetting() {
  yield takeEvery(actions.CANCEL_REQUEST, function* ({ payload }) {
    const { batchCrawlSettingId, resolve, reject } = payload;
    try {
      const response = yield call(rakutenScoringSettingService.cancel, batchCrawlSettingId);
      yield put({ type: actions.CANCEL_SUCCESS });
      resolve(response);
    } catch (error) {
      yield put({ type: actions.CANCEL_ERROR, error: error.response });
      reject(error);
    }
  });
}

function* getCurrent() {
  yield takeEvery(actions.CURRENT_REQUEST, function* ({ payload }) {
    const { batchCrawlSettingId, resolve, reject } = payload;
    try {
      const response = yield call(rakutenScoringSettingService.getCurrent, batchCrawlSettingId);
      yield put({ type: actions.CURRENT_SUCCESS, current: response });
      resolve(response);
    } catch (error) {
      yield put({ type: actions.CURRENT_ERROR, error: error.response });
      reject(error);
    }
  });
}

function* searchSettings() {
  yield takeEvery(actions.SEARCH_REQUEST, function* ({ payload }) {
    const { keyword, executionType, isActive, latestStatus, page, size, resolve, reject } =
      payload || {};
    try {
      const response = yield call(rakutenScoringSettingService.search, {
        keyword,
        executionType,
        isActive,
        latestStatus,
        page,
        size,
      });
      resolve && resolve(response);
      const rawItems = response?.items ?? (Array.isArray(response) ? response : null);
      const items = Array.isArray(rawItems) ? rawItems : [];
      const total = Number(response?.total);
      yield put({
        type: actions.SEARCH_SUCCESS,
        items,
        total: Number.isFinite(total) ? total : 0,
      });
    } catch (error) {
      yield put({ type: actions.SEARCH_ERROR, error: error.response });
      reject && reject(error);
    }
  });
}

function* deleteSetting() {
  yield takeEvery(actions.DELETE_REQUEST, function* ({ payload }) {
    const { batchCrawlSettingId, resolve, reject } = payload;
    try {
      const response = yield call(rakutenScoringSettingService.delete, {
        batchCrawlSettingId,
      });
      yield put({ type: actions.DELETE_SUCCESS });
      resolve && resolve(response);
    } catch (error) {
      yield put({ type: actions.DELETE_ERROR, error: error.response });
      reject && reject(error);
    }
  });
}

function* getHistories() {
  yield takeEvery(actions.HISTORIES_REQUEST, function* ({ payload }) {
    const { batchCrawlSettingId, resolve, reject } = payload;
    try {
      const response = yield call(rakutenScoringSettingService.getHistories, batchCrawlSettingId);
      const raw = response?.histories ?? [];
      const histories = Array.isArray(raw) ? raw : [];
      yield put({ type: actions.HISTORIES_SUCCESS, histories });
      resolve(histories);
    } catch (error) {
      yield put({ type: actions.HISTORIES_ERROR, error: error.response });
      reject(error);
    }
  });
}

function* uploadToS3() {
  yield takeEvery(actions.UPLOAD_TO_S3_REQUEST, function* ({ payload }) {
    const { file, resolve, reject } = payload;
    let step = "presigned-url";
    let ticket = null;
    try {
      ticket = yield call(uploadService.createPresignedUploadUrl, file.name);
      step = "s3-put";
      yield call(uploadService.putToS3, ticket.url, ticket.headers, file);
      yield put({ type: actions.UPLOAD_TO_S3_SUCCESS });
      resolve(ticket.s3Path);
    } catch (error) {
      console.error("[RakutenScoring] S3 upload failed", {
        step,
        message: error?.message,
        status: error?.response?.status,
        fileName: file?.name,
        fileSize: file?.size,
        s3Path: ticket?.s3Path,
        url: ticket?.url,
        headers: ticket?.headers,
      });
      yield put({ type: actions.UPLOAD_TO_S3_ERROR, error: error.response });
      reject({ ...error, step });
    }
  });
}

export default function* rootSaga() {
  yield all([
    fork(createSetting),
    fork(getDetail),
    fork(updateSetting),
    fork(executeSetting),
    fork(cancelSetting),
    fork(getCurrent),
    fork(getHistories),
    fork(searchSettings),
    fork(deleteSetting),
    fork(uploadToS3),
  ]);
}
